import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Subscription  {
    _originalTypeClassName = "zvelton_Backoffice.BO.Subscription";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Subscription.translate = translateService;
}
this.Applications = [];
this.Users = [];
this.BillingDetails = new Domain.BillingDetails();
this.Id = null;
this.Name = null;
this.CreditsEUR = null;
this.ExternalSystem = null;
this.ExternalSystemId = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
CreditsEUR:any;
ExternalSystem:any;
ExternalSystemId:any;
Applications:any;
Users:any;
BillingDetails:any;
DefaultPricelist:any;
static setApplications = ($this, items) => {
                if (items == null) items = [];
                if ($this.Applications == null) $this.Applications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Applications.length > 0) {
                    Domain.Subscription.removeApplications($this, $this.Applications[0]);
                }

                Domain.Subscription.addManyApplications($this, copyItems);
            }
static addManyApplications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Subscription.addApplications($this, items[i]);
                }
            }
static addApplications = ($this, item) => {
                if ($this.Applications == null) $this.Applications = [];
                if (item == null || $this.Applications.indexOf(item) > -1) return;
                $this.Applications.push(item);
if (item.Subscription != $this) {
Domain.Application.setSubscription(item, $this);
}
}
static addRangeApplications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Subscription.addApplications($this, item));
            }
static removeApplications = ($this, item) => {
                if ($this == null || $this.Applications == null || $this.Applications.indexOf(item) === -1) return;
                var _index = $this.Applications.indexOf(item);
                $this.Applications.splice(_index, 1);
item.Subscription = null;
}
static clearApplications = ($this) => { $this.Applications = null; }
static setUsers = ($this, items) => {
                if (items == null) items = [];
                if ($this.Users == null) $this.Users = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Users.length > 0) {
                    Domain.Subscription.removeUsers($this, $this.Users[0]);
                }

                Domain.Subscription.addManyUsers($this, copyItems);
            }
static addManyUsers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Subscription.addUsers($this, items[i]);
                }
            }
static addUsers = ($this, item) => {
                if ($this.Users == null) $this.Users = [];
                if (item == null || $this.Users.indexOf(item) > -1) return;
                $this.Users.push(item);
if (item.Subscription != $this) {
Domain.SubscriptionAccess.setSubscription(item, $this);
}
}
static addRangeUsers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Subscription.addUsers($this, item));
            }
static removeUsers = ($this, item) => {
                if ($this == null || $this.Users == null || $this.Users.indexOf(item) === -1) return;
                var _index = $this.Users.indexOf(item);
                $this.Users.splice(_index, 1);
item.Subscription = null;
}
static clearUsers = ($this) => { $this.Users = null; }
static setBillingDetails = ($this, value) => {
var oldValue = $this.BillingDetails;
$this.BillingDetails = value;
if (value != null) {
}
}
static setDefaultPricelist = ($this, value) => {
var oldValue = $this.DefaultPricelist;
$this.DefaultPricelist = value;
if (value != null) {
}
}

static Initialize(name: any,company: any): any{let subscription = new Domain.Subscription();
subscription.Name = name;
subscription.CreditsEUR = 0;
Domain.Subscription.setBillingDetails(subscription, new Domain.BillingDetails());
subscription.BillingDetails.Company = company;
return subscription;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}